<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="domobject_keyno_parent" [ttModel]="page.domobject_keyno_parent" ttReadonly></tt-input>
        <tt-input ttLabel="domobject_name_parent" [ttModel]="page.domobject_name_parent" ttReadonly></tt-input>
        <tt-input ttLabel="domobject_keyno_child" [ttModel]="page.domobject_keyno_child" ttReadonly></tt-input>
        <tt-input ttLabel="domobject_name_child" [ttModel]="page.domobject_name_child" ttReadonly></tt-input>
        <tt-select
            ttLabel="domobjecttype"
            [(ttModel)]="page.domobjecttype_keyno"
            [ttData]="selectListDomObjectTypes"
            ttDataId="domobjecttype_keyno"
            ttDataName="domobjecttype_name"
        ></tt-select>
        <tt-input ttLabel="domobjecttype_name" [ttModel]="page.domobjecttype_name" ttReadonly></tt-input>
    </tt-card>
</tt-page>
